"use strict";
exports.__esModule = true;
exports.WITHDRAW_FUNDS_ERROR_HANDLING = void 0;
exports.WITHDRAW_FUNDS_ERROR_HANDLING = {
    TEN_SECOND_WAIT: {
        HEADER: 'Slow down!',
        BODY: 'You need to wait 10 seconds between withdrawal attempts. Try again in a moment.',
        CTA: 'Close'
    },
    LAST_WITHDRAWAL_IN_PROGRESS: {
        HEADER: 'Withdrawal in progress',
        BODY: 'We’re still working on your last withdrawal! Give us 5 minutes to finish up and then try again.',
        CTA: 'Close'
    },
    WITHDRAWAL_LIMIT_REACHED: {
        HEADER: 'Withdrawal limit reached',
        BODY_TEXT_1: 'You’ve already made 3 withdrawals within the last 30 days.',
        BODY_TEXT_2: 'You’ll be eligible to make your next withdrawal on {{nextEligibilityDate}}.',
        CTA: 'Close'
    }
};
